function directionColor(direction) {
  if (direction === 'up') return 'text-[#15803d]';
  if (direction === 'down') return 'text-[#b91c1c]';
  return 'text-[#737373]';
}

export default function BriefMarketPulse({ marketPulse }) {
  const tickers = marketPulse?.tickers || [];
  if (tickers.length === 0) return null;

  const asOf = marketPulse.asOf || '';

  return (
    <section className="mb-10 border border-black">
      <div className="bg-black px-6 sm:px-8 py-4 flex flex-wrap items-center justify-between gap-2">
        <h2 className="font-sans font-black text-[14px] sm:text-[15px] tracking-[0.14em] uppercase text-white m-0">
          Aerospace Market Pulse
        </h2>
        {asOf ? (
          <span className="font-mono text-[12px] text-[#9a9a9a] tracking-[0.18em]">
            {asOf}
          </span>
        ) : null}
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-[#E5E5E5] bg-white">
        {tickers.map((t, i) => (
          <div key={i} className="px-4 sm:px-5 py-5">
            <div className="font-mono text-[12px] text-[#737373] tracking-wide font-semibold mb-1.5">
              {t.label}
            </div>
            <div className="font-mono text-[20px] sm:text-[22px] text-black font-bold mb-1">
              {t.value || '—'}
            </div>
            <div className={`font-mono text-[12px] font-bold ${directionColor(t.direction)}`}>
              {t.change}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
